import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import testimonialsData from "../data/mogCommentData.json";

const truncateText = (text, maxLength = 150) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

const CustomTestimonialsSlider = () => {
  const { t } = useTranslation();
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    setTestimonials(testimonialsData.testimonials);
  }, []);

  if (testimonials.length === 0) return null;

  const doubled = [...testimonials, ...testimonials];

  return (
    <div id="about-us" className="bg-white text-center py-16">
      <h2 className="text-[20px] sm:text-[26px] md:text-[32px] font-roboto text-text mb-2 px-4 break-words">
        {t("clientHeader")}
      </h2>
      <p className="text-text text-[14px] sm:text-[18px] md:text-[20px] italic font-poppins mb-8 px-4">
        {t("clientTitle")}
      </p>

      <div className="relative bg-tertiary py-8 rounded-[50px] mx-4 sm:mx-8 overflow-hidden">
        {/* Sol fade */}
        <div
          className="absolute left-0 top-0 bottom-0 w-20 sm:w-32 z-10 pointer-events-none rounded-l-[50px]"
          style={{ background: "linear-gradient(to right, #f4efea, transparent)" }}
        />
        {/* Sağ fade */}
        <div
          className="absolute right-0 top-0 bottom-0 w-20 sm:w-32 z-10 pointer-events-none rounded-r-[50px]"
          style={{ background: "linear-gradient(to left, #f4efea, transparent)" }}
        />

        <style>{`
          @keyframes testimonial-scroll {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .testimonial-track {
            animation: testimonial-scroll 40s linear infinite;
          }
          .testimonial-track:hover {
            animation-play-state: paused;
          }
        `}</style>

        <div className="overflow-hidden">
          <div
            className="testimonial-track flex gap-4"
            style={{ width: `${doubled.length * (300 + 16)}px` }}
          >
            {doubled.map((testimonial, index) => (
              <div
                key={`${testimonial.id}-${index}`}
                className="flex-shrink-0 w-[270px] sm:w-[300px]"
              >
                <div className="bg-white p-6 rounded-[30px] shadow-sm flex flex-col justify-between items-center text-center h-[230px] sm:h-[250px]">
                  <p
                    className="font-poppins text-text text-[14px] sm:text-[15px] italic leading-relaxed"
                    title={testimonial.text}
                  >
                    "{truncateText(testimonial.text)}"
                  </p>
                  <div className="mt-4">
                    <h4 className="text-gray-800 font-semibold font-poppins text-[14px] sm:text-[15px]">
                      {testimonial.userName}
                    </h4>
                    <p className="text-yellow-400 text-[15px] mt-0.5">{"★".repeat(5)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomTestimonialsSlider;
